<template>
  <div class="login-container">
    <a-card title="用户登录" class="login-card">
      <a-form
          :model="formState"
          name="login"
          @finish="onFinish"
          @finishFailed="onFinishFailed"
      >
        <a-form-item
            name="username"
            :rules="[{ required: true, message: '请输入用户名!' }]"
        >
          <a-input v-model:value="formState.username" placeholder="用户名" />
        </a-form-item>

        <a-form-item
            name="password"
            :rules="[{ required: true, message: '请输入密码!' }]"
        >
          <a-input-password v-model:value="formState.password" placeholder="密码" />
        </a-form-item>

        <a-form-item>
          <a-checkbox v-model:checked="formState.remember">
            记住我
          </a-checkbox>
        </a-form-item>

        <a-form-item>
          <div id="link-container">
            <router-link to="/register" id="enter-backend">新用户？去注册...</router-link>
            <router-link to="/forgot" id="enter-backend">忘记密码...</router-link>
          </div>
          <a-button type="primary" html-type="submit" block>
            登录
          </a-button>


        </a-form-item>
      </a-form>
    </a-card>
  </div>
</template>

<script setup>
import { reactive } from "vue"
import { message } from "ant-design-vue"
import router from "@/router/index"
import request from "@/utils/request.js";
import {HttpStatusCode} from "axios";

const formState = reactive({
  username: "",
  password: "",
  remember: true
})

const onFinish = async (values) => {
  // console.log("登录成功:", values)
  try {
    const res = await request.post("/auth/login", {
      username: formState.username,
      password: formState.password,
      rememberMe: formState.remember
    })
    message.success("登录成功！")
    const token = res.data
    localStorage.setItem("token", token)
    await router.replace("/");
  } catch (err) {
    message.error(err.response.data)
  }
}

const onFinishFailed = () => {
  message.error("请填写完整信息！")
}

</script>

<style scoped>
.login-container {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(120deg, #1890ff, #87cefa);
}

.login-card {
  width: 350px;
  border-radius: 10px;
}
#link-container{
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
}
</style>